window.copyElementTextById = (elementId, columnsPerRow = 5) => {
    const el = document.getElementById(elementId);
    if (!el) return;

    const cells = Array.from(el.childNodes)
        .filter(node => node.nodeType === Node.ELEMENT_NODE)
        .map(cell => cell.textContent.trim());

    const rows = [];
    for (let i = 0; i < cells.length; i += columnsPerRow) {
        rows.push(cells.slice(i, i + columnsPerRow).join(', '));
    }

    const csv = rows.join('\n');
    navigator.clipboard.writeText(csv);
};